import { Ticket } from 'api';
import { Box, Button, Typography } from 'ui';

export const Success = ({ ticket }: { ticket: Ticket }) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" padding={3}>
      <Typography variant="h5" mb={2} align="center">
        Support Issue Created Successfully!
      </Typography>
      <Typography variant="body1" mb={2}>
        You can view the issue using the link below.
      </Typography>
      <Button variant="primary" component="a" href={ticket.external_link} target="_blank" rel="noopener noreferrer">
        View Support Issue
      </Button>
    </Box>
  );
};
